import { render, staticRenderFns } from "./home-owner-sm-menu.vue?vue&type=template&id=f170944a&scoped=true"
import script from "./home-owner-sm-menu.vue?vue&type=script&lang=js"
export * from "./home-owner-sm-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f170944a",
  null
  
)

export default component.exports